import type { FC } from 'react';
import { useRef, useEffect } from 'react';
import { ApolloProvider as ApolloProviderBase } from '@apollo/client';
import { useStore } from '../store/restash';
import { createApolloClient } from '../graphql/client';
import config from '../config';

const ApolloProvider: FC = ({ children }) => {
  const [store, dispatch] = useStore();
  const client = useRef<ReturnType<typeof createApolloClient> | null>(null);

  if (!client.current) {
    client.current = createApolloClient(
      dispatch,
      config.titanUrl ?? '',
      config.titanApiKey ?? ''
    );
  }

  useEffect(() => {
    if (client.current) {
      client.current.updateStore(store);
    }
  }, [store]);

  return <ApolloProviderBase client={client.current}>{children}</ApolloProviderBase>;
};

export default ApolloProvider;
